export function genererIdentifiantAleatoire() {
  return Math.random().toString(36).substring(2, 12)
}

export function naviguerVers(chemin) {
  window.history.pushState(null, "", chemin)
  window.dispatchEvent(new PopStateEvent("popstate"))
}
